import React from 'react';
import { createRoot } from 'react-dom/client'; // For React 18
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App/App';
import { AuthContextProvider } from './contexts/authContext';
import { ThemeContextProvider } from './contexts/themeContext';
import './i18n';
import reportWebVitals from './reportWebVitals';
import './styles/styles.scss';
import apiInterceptor from './utils/apiInterceptor';
import { AccessContextProvider } from './contexts/accessContext';

apiInterceptor.setup();

const children = (
	<AuthContextProvider>
		<AccessContextProvider>
			<ThemeContextProvider>
				<Router>
					<React.StrictMode>
						<App />
					</React.StrictMode>
				</Router>
			</ThemeContextProvider>
		</AccessContextProvider>
	</AuthContextProvider>
);

const container = document.getElementById('root');

// ReactDOM.render(children, container); // For React 17
createRoot(container as Element).render(children); // For React 18

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
